module.exports = __webpack_public_path__ + "static/media/screen-icon.cc4dc98e.svg";